import type { SVGProps } from 'react';

const SvgTargetedCampaign = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <g fill={props.color} data-name="smart-send-time">
      <path d="m.293 30.357 5.96-5.821L7.3 25.609l-5.958 5.82zM4.89 30.31l2.733-2.67 1.049 1.073-2.733 2.67zM.339 25.827l2.732-2.669 1.048 1.073-2.732 2.67z" />
      <path d="m.74 21.06 7.5 2.6 2.42 7.55a.76.76 0 0 0 .69.52.76.76 0 0 0 .7-.48l6.41-16.66a.74.74 0 0 0-.95-1l-16.8 6a.76.76 0 0 0-.5.71.76.76 0 0 0 .53.76m10.7 7.67-1.75-5.45 6.17-6Zm3.37-12.54-6.17 6-5.4-1.87Z" />
      <path d="M7.42 15.43a10.4 10.4 0 0 1-.16-2.09A11.28 11.28 0 0 1 18.54 2.28h.23a11.3 11.3 0 0 1 11.06 11.51 11.24 11.24 0 0 1-13.37 10.86L16 26.09a12.6 12.6 0 0 0 2.32.26h.26a12.8 12.8 0 0 0 12.75-12.53 12.79 12.79 0 1 0-25.57-.51A12.3 12.3 0 0 0 6 15.9Z" />
      <path d="m18 20.21-.5 1.46a7 7 0 0 0 .91.07h.17a8.18 8.18 0 1 0-8.18-8.35 7.5 7.5 0 0 0 .05 1.06l1.43-.45a5 5 0 0 1 0-.56 6.67 6.67 0 0 1 6.67-6.54h.14a6.68 6.68 0 0 1 6.54 6.81 6.68 6.68 0 0 1-6.81 6.54 3 3 0 0 1-.42-.04" />
      <path d="m19.53 15.62-.53 1.7a3.79 3.79 0 1 0-4.14-4.27l1.72-.56a2.1 2.1 0 0 1 .43-.57 2.24 2.24 0 0 1 1.58-.64h.05a2.28 2.28 0 0 1 .94 4.34Z" />
    </g>
  </svg>
);

export default SvgTargetedCampaign;
